// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-essays-js": () => import("./../../../src/templates/essays.js" /* webpackChunkName: "component---src-templates-essays-js" */)
}

